<template lang="html">
  <section class="call-attendees-container"></section>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "call-attendees-container",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      app() {
        return this.apps.find(app => app.uuid === this.appId);
      },
      de() {
        return this.app.dataElements[this.deId];
      }
    }
  };
</script>

<style scoped lang="scss"></style>
